<div class="c-modal__inner">
  <form class="c-modal__form c-form c-form--d">
    <div class="c-modal__head">
      <div class="row">
        <div class="c-modal__close" (click)="close()">
          <p500-ui-icon name="controls-close"></p500-ui-icon>
        </div>
        <div class="c-modal__title col-12">
          {{ settings.title }}
        </div>
        <div class="c-modal__subtitle col-12">ID: {{ id }}</div>
      </div>
    </div>

    <div class="c-modal__body">
      <p500-ui-tabs *ngIf="settings.tabs.length > 1" [key]="settings.key">
        <p500-ui-tab *ngFor="let tab of settings.tabs" [tabTitle]="tab.title">
          <div class="mt-20">
            <ng-container p500UIComponentOutlet [component]="tab.component" [settings]="tab.settings"></ng-container>
          </div>
        </p500-ui-tab>
      </p500-ui-tabs>

      <ng-container *ngIf="settings.tabs.length <= 1">
        <ng-container *ngFor="let tab of settings.tabs">
          <ng-container p500UIComponentOutlet [component]="tab.component" [settings]="tab.settings"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="c-modal__footer">
      <div class="c-modal__action">
        <button p500-ui-button [stroked]="true" type="button" i18n="@@common.close" (click)="close(); $event.preventDefault()">
          Close
        </button>
      </div>

      <div *rbac="rbacProperty" class="c-modal__action">
        <a p500-ui-button [routerLink]="link" i18n="@@common.full_information">Full Information</a>
      </div>
    </div>
  </form>
</div>
